/**
 *
 * PasswordRequirementsModal
 *
 */

import React from 'react';
import {
  Wrapper,
  Text,
} from './styledComponents'

import PasswordSVG from 'components/Icon/PasswordSVG';
import Modal from 'components/Modal';
import H1 from 'components/H1';
import Icon from 'components/Icon';

const UpgradeToEnterPriseModal = ({ close }) => (
  <Modal close={close} title='Upgrade to Enterprise'>
    <Wrapper>
      <Icon
        width='100px'
        height='100px'
        name='rocket'
        viewBox='0 0 76 76'
      />
      <H1>Get More Oomph! </H1>
      <Text>
        Upgrading this to an enterprise channel will unlock powerful marketing features like custom logos, photo filters, lead collection, facial-recognition demographic and more!
      </Text>
    </Wrapper>
  </Modal>
);

export default UpgradeToEnterPriseModal;
